import React, {useContext} from 'react';
import {Button, Col, Descriptions, Row, Space, theme} from 'antd';
import {observer} from "mobx-react";
import {Link, useLoaderData, useNavigate} from "react-router-dom";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import AccessUtil from "../../../components/util/access.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {AgencyViewResponse} from "../../../types/modules/agency/response";
import {ViewCardStyled} from "../../../components/styled/card.styled";
import FoAccessUtil from "../../../components/util/foAccess.util";
import FoLink from "../../../components/link/fo.link";
import {StoreContext} from "../../../store.context";
import {Helmet} from "react-helmet-async";

export const View: React.FC = observer(() => {
    const { token } = theme.useToken();
    const { appStore: {
        countries,
    }} = useContext(StoreContext);

    const navigate = useNavigate();
    const data: AgencyViewResponse = useLoaderData() as AgencyViewResponse;

    return (
            <>
                <Helmet>
                    <title>{`CL BO - ${data?.name} - ${data?.tpNumber}`}</title>
                </Helmet>
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            <Row gutter={[8, 8]}>
                <Col span={12}>
                    <Space direction={'vertical'} style={{ width: '100%' }}>
                        <ViewCardStyled title={
                            <Translate message={`agency.title.company`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    {data.id && <Descriptions.Item label={<Translate message={`agency.fields.relationalId`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.id }</Descriptions.Item>}
                                    <Descriptions.Item label={<Translate message={`agency.fields.name`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.name }</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.externalId`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.externalId }</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.initials`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.initials }</Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`agency.title.contact_data`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`companyContactData.fields.phone`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.contactData.phone }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyContactData.fields.email`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.contactData.email }
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`agency.title.address`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.country`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { countries.find((country) => { return  country.id === data.address.country})?.name }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.postalCode`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.postalCode }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.houseNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.houseNumber }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.houseNumberAdditions`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.houseNumberAdditions }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.street`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.street }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.city`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.city }
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`agency.title.updates`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`global.title.created_or_updated_date`} domain={TranslationDomainEnum.MESSAGES} />} span={3}>
                                        { data.modifiedDate }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`global.title.created_or_updated_by`} domain={TranslationDomainEnum.MESSAGES} />} span={3}>
                                        {data.modifiedBy ? (
                                                <AccessUtil access={{ routeName: 'user_view', attributes: [{ id: data.modifiedBy.id  }]}}>
                                                    <AccessUtil access={{ routeName: 'user_view', attributes: [{ id: data.modifiedBy.id  }]}} onDenied={() => {
                                                        return data.modifiedBy?.username ?? data.modifiedBy?.id;
                                                    }}>
                                                        <Link target={"_blank"} to={`/user/${data.modifiedBy?.id}/view`}>{ data.modifiedBy.username ?? data.modifiedBy.id }</Link>
                                                    </AccessUtil>
                                                </AccessUtil>
                                        ) : (
                                                <Translate message={`global.system`} domain={TranslationDomainEnum.MESSAGES} />
                                        )}
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>
                    </Space>
                </Col>
                <Col span={12}>
                    <Space direction={'vertical'} style={{ width: '100%' }}>
                        <ViewCardStyled title={
                            <Translate message={`agency.title.reference_numbers`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`agency.fields.tpNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.tpNumber }</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.wft`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.wft }</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.chamberOfCommerceNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.chamberOfCommerceNumber }</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.crmId`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.crmId }</Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`agency.title.servicer`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`agency.fields.servicerTpNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.servicer.tpNumber }</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.servicerName`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        <AccessUtil access={{ routeName: 'servicer_view', attributes: [{ id: data.servicer.id  }]}} onDenied={() => {
                                            return data.servicer.name;
                                        }}>
                                            <Link target={"_blank"} to={`/servicer/${data.servicer?.id}/view`}>{ data.servicer.name }</Link>
                                        </AccessUtil>
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.servicerProductGroups`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.servicer.allowedProductTypes.map(
                                                (pt, index) => (
                                                        <span key={index}>
                                                    <Translate message={pt.name} domain={TranslationDomainEnum.MESSAGES} />
                                                            { data.servicer.allowedProductTypes.length === index + 1 ? null : ', '}
                                                </span>
                                                )
                                        ) }
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`agency.title.contract_information`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`agency.fields.internetBroker`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.internetBroker ? <Translate message={`global.yes`} /> : <Translate message={`global.no`} /> }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.hasAccess`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.hasAccess ? <Translate message={`global.yes`} /> : <Translate message={`global.no`} /> }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.activeContract`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.activeContract ? <Translate message={`global.yes`} /> : <Translate message={`global.no`} /> }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.canCreateTrialPolicy`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.canCreateTrialPolicy ? <Translate message={`global.yes`} /> : <Translate message={`global.no`} /> }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.canCreateAfterSales`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.canCreateAfterSales ? <Translate message={`global.yes`} /> : <Translate message={`global.no`} /> }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.restrictedProductTypes`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.restrictedProductTypes.length ? data.restrictedProductTypes.map(
                                            (pt, index) => (
                                                <span key={index}>
                                                    <Translate message={pt.name} domain={TranslationDomainEnum.MESSAGES} />
                                                    { data.restrictedProductTypes.length === index + 1 ? null : ', '}
                                                </span>
                                            )
                                        ) : <Translate message={`global.empty_value`} /> }
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`agency.title.reference_numbers`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`companyBankData.fields.iban`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.bankData?.iban }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyBankData.fields.accountHolderName`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.bankData?.accountHolderName }
                                    </Descriptions.Item>

                                    <Descriptions.Item label={<Translate message={`agency.fields.stopExcasso`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.stopExcasso ? <Translate message={`global.yes`} /> : <Translate message={`global.no`} /> }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`agency.fields.sendMonthlyOverview`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.sendMonthlyOverview ? <Translate message={`global.yes`} /> : <Translate message={`global.no`} /> }
                                    </Descriptions.Item>
                                    {
                                        data.monthlyOverviewEmail && (
                                            <Descriptions.Item label={<Translate message={`agency.fields.monthlyOverviewEmail`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                                { data.monthlyOverviewEmail }
                                            </Descriptions.Item>
                                        )
                                    }
                                </Descriptions>
                            </div>
                        </ViewCardStyled>
                    </Space>
                </Col>
            </Row>

            <ButtonBar>
                <AccessUtil access={{ routeName: 'agency_edit', attributes: [{ id: data.id }]}}>
                    <Space>
                        <Button type={`primary`} onClick={ () => navigate(`/agency/${data.id}/edit`) }>
                            <Translate message={`global.button.edit`} />
                        </Button>
                    </Space>
                </AccessUtil>

                <AccessUtil access={{ routeName: 'agency_view_history', attributes: [{ id: data.id }]}}>
                    <Space>
                        <Button type={`primary`} className={`ant-btn-secondary`} onClick={ () => navigate(`/agency/${data.id}/view_history`) }>
                            <Translate message={`global.button.view_history`} />
                        </Button>
                    </Space>
                </AccessUtil>

                <Button type="primary" className={`ant-btn-secondary`} onClick={ () => navigate(`/agency`) }>
                    <Translate message={`global.button.back_to_list`} />
                </Button>

                <FoAccessUtil>
                    <Space>
                        <FoLink path={`/agency/${data.id}/view_bo_id`} message="global.button.view_in_fo"></FoLink>
                    </Space>
                </FoAccessUtil>

            </ButtonBar>
        </Space>
            </>
    )
})